import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditCharterCustomerInfoHeadingComponent } from './edit-charter-customer-info-heading.component';

@NgModule({
  declarations: [EditCharterCustomerInfoHeadingComponent],
  exports: [EditCharterCustomerInfoHeadingComponent],
  imports: [CommonModule],
})
export class EditCharterCustomerInfoHeadingModule {}
